import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  OfficeSuppliesRefurbishType,
  OfficeSuppliesRefurbishValues,
  Source,
  SourceValues,
  ValuesOfficeSuppliesRefurbish,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionOfficeSuppliesRefurbishDto } from './dto.type';

export class QuestionOfficeSuppliesRefurbishMapper {
  static dtoToEntity(
    dto: QuestionOfficeSuppliesRefurbishDto,
  ): ImpactCo2Answer<ValuesOfficeSuppliesRefurbish> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'OFFICE_SUPPLIES_REFURBISH',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        officeSuppliesRefurbishType:
          validateValueInType<OfficeSuppliesRefurbishType>(
            dto.officeSuppliesRefurbishType,
            OfficeSuppliesRefurbishValues,
          ),
        count: Number.parseFloat(dto.count.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesOfficeSuppliesRefurbish>,
    projectId: number,
  ): Omit<
    QuestionOfficeSuppliesRefurbishDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      officeSuppliesRefurbishType: answer.values.officeSuppliesRefurbishType,
      count: answer.values.count,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
